import React from 'react';
import UserAvatar from '../user/UserAvatar';
import { convertSlackEmojis } from '../../utils/emojiConverter';

const AppreciationCard = ({ appreciation }) => {
  const { sender, receiver, message, created_at, company_values } = appreciation;
  
  // Format the date (could be moved to a utility function)
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInMs = now - date;
    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    // More granular time display
    if (diffInMinutes < 1) return 'Just now';
    if (diffInMinutes < 60) return `${diffInMinutes} ${diffInMinutes === 1 ? 'minute' : 'minutes'} ago`;
    if (diffInHours < 24) return `${diffInHours} ${diffInHours === 1 ? 'hour' : 'hours'} ago`;
    if (diffInDays === 1) return 'Yesterday';
    if (diffInDays < 7) return `${diffInDays} days ago`;
    if (diffInDays < 30) return `${Math.floor(diffInDays / 7)} ${Math.floor(diffInDays / 7) === 1 ? 'week' : 'weeks'} ago`;
    return `${Math.floor(diffInDays / 30)} ${Math.floor(diffInDays / 30) === 1 ? 'month' : 'months'} ago`;
  };

  return (
    <div className="bg-white shadow-sm rounded-lg overflow-hidden">
      <div className="p-4 border-b border-gray-100">
        <div className="flex justify-between items-start">
          <div className="flex">
            <UserAvatar user={sender} size="small" />
            <div className="ml-3">
              <p className="text-sm font-medium text-gray-900">{sender.full_name}</p>
              <p className="text-xs text-gray-500">to {receiver.full_name}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="p-4">
        <p className="text-sm text-gray-800">{convertSlackEmojis(message)}</p>
        {company_values && company_values.length > 0 && (
          <div className="mt-3 flex flex-wrap gap-1">
            {company_values.map((value, index) => (
              <span key={index} className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-50 text-blue-700">
                {value}
              </span>
            ))}
          </div>
        )}
        <div className="mt-3 text-xs text-gray-500">
          <span>{formatDate(created_at)}</span>
        </div>
      </div>
    </div>
  );
};

export default AppreciationCard;
